import React from "react";
import {useTranslation} from 'react-i18next';
import {Typography, createTheme, ThemeProvider} from '@mui/material';
import {Link} from 'react-router-dom';

import {MdOutlineFacebook} from "react-icons/md";
import {SlSocialLinkedin} from 'react-icons/sl';
import {RiTwitterXLine} from 'react-icons/ri';
import {TbBrandThreads} from "react-icons/tb";
import {BsShare} from 'react-icons/bs';

import './Footer.css'

const theme = createTheme();

theme.typography.h3 = {
    fontFamily: "'Montserrat', sans-serif",
    fontWeight: '500',
    fontSize: '0.95rem',
    color: '#1C1B1F',
    marginBottom: '1rem',
    textDecoration: "none",
    boxShadow: "none",
    display: 'block',
    transition: 'color 0.2s ease, padding-left 0.2s ease',
    '&:hover': {
        color: '#6750A4',
        paddingLeft: '4px',
        cursor: 'pointer'
    },
    '@media (max-width:800px)': {
        textAlign: 'center'
    },
};

const Footer = () => {
    const {t} = useTranslation();
    const token = localStorage.getItem('AUTHORIZATION_TOKEN_BLOG');

    return (
        <div className='main-footer'>
            <div className="row">
                {/* Column 1 */}
                <div style={{textAlign: 'center'}}>
                    <img src={'vividKidsLogo.svg'} alt="Logo"/>
                    <p>&copy;{t('All rights reserved')}</p>
                </div>
                {/* Column 2 */}
                <div>
                    <ThemeProvider theme={theme}>
                        <div>
                            <Typography variant="h3" component={Link} to='/news-events'>{t('News & Events')}</Typography>
                        </div>
                        <div>
                            <Typography variant="h3" component={Link}
                                        to='/products'>{t('Sponsor\'s Products')}</Typography></div>
                        <div>
                            <Typography variant="h3" component={Link} to='/about'>{t('About')}</Typography>
                        </div>


                    </ThemeProvider>
                </div>
                {/* Column 3 */}
                <div>
                    <ThemeProvider theme={theme}>
                        <div>
                            <Typography variant="h3" component={Link} to='support'>{t('Support')}</Typography>
                        </div>
                        {
                            token &&
                            <div>
                                <Typography variant="h3" component={Link} to='write'>{t('Write')}</Typography>
                            </div>
                        }
                    </ThemeProvider>
                </div>
                {/* Column 4 */}
                <div>
                    <p>{t('Follow Us')}</p>
                    <div className="socials">
                        <a href={'https://twitter.com/leapneuro?lang=en'} aria-label="Twitter"><RiTwitterXLine/></a>
                        <a href={'https://www.threads.net/@neuroleap1'} aria-label="Threads"><TbBrandThreads/></a>
                        <a href={'https://m.facebook.com/Neuro-Leap-Corp-278266009350133/'} aria-label="Facebook">
                            <MdOutlineFacebook/>
                        </a>
                        <a href={'https://www.linkedin.com/company/neuroleap-corp/'} aria-label="LinkedIn"><SlSocialLinkedin/></a>
                        <a href={window.location.pathname} aria-label="Share"><BsShare/></a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer
